const syComp = () => import("@/pages/syComp/syComp/syComp.vue");
const syCompBreedinfo = () => import("@/pages/syComp/syCompBreedinfo/syCompBreedinfo.vue");
const syCompGoods = () => import("@/pages/syComp/syCompGoods/syCompGoods.vue");
const syCompInfo = () => import("@/pages/syComp/syCompInfo/syCompInfo.vue");
const syCompOrig = () => import("@/pages/syComp/syCompOrig/syCompOrig.vue");
const syCompStaff = () => import("@/pages/syComp/syCompStaff/syCompStaff.vue");
const syCompZs = () => import("@/pages/syComp/syCompZs/syCompZs.vue");
const sysCompDetail = () => import("@/pages/syComp/comp/compDetail.vue");
const operator = () => import("@/pages/syComp/syCompOperator/syCompOperator");

const syOperLog = () => import("@/pages/syComp/syOperLog/syOperLog");
const batch = () => import("@/pages/syComp/batch/batch");

// 设备信息
const device = () => import("@/pages/syComp/device/device");

const syPdaVer = () => import("@/pages/syPda/syPdaVer/syPdaVer");

const sySafeDete = () => import("@/pages/sySafe/sySafeDete/sySafeDete");

const labelComp = () => import("@/pages/labelComp/labelComp");
const labelMarks = () => import("@/pages/labelMarks/labelMarks");


export default [
  {
    path: "/syComp/syComp",
    name: "syComp",
    component: syComp,
    meta: {
      title: "企业信息",
      noCache: true,
      affix: true,
      path: ["企业管理", "企业信息"]
    }
  },
  {
    path: "/syComp/syCompBreedinfo",
    name: "syCompBreedinfo",
    component: syCompBreedinfo,
    meta: {
      title: "生产信息",
      noCache: true,
      affix: true,
      path: ["企业管理", "生产信息"]
    },
  },
  {
    path: "/syComp/syCompGoods",
    name: "syCompGoods",
    component: syCompGoods,
    meta: {
      title: "商品信息",
      noCache: true,
      affix: true,
      path: ["企业管理", "商品信息"]
    },
  },
  {
    path: "/syComp/syCompInfo",
    name: "syCompInfo",
    component: syCompInfo,
    meta: {
      title: "附加信息",
      noCache: true,
      affix: true,
      path: ["企业管理", "附加信息"]
    },
  },
  {
    path: "/syComp/syCompOrig",
    name: "syCompOrig",
    component: syCompOrig,
    meta: {
      title: "产地信息",
      noCache: true,
      affix: true,
      path: ["企业管理", "产地信息"]
    },
  },
  {
    path: "/syComp/syCompStaff",
    name: "syCompStaff",
    component: syCompStaff,
    meta: {
      title: "员工信息",
      noCache: true,
      affix: true,
      path: ["企业管理", "员工信息"]
    },
  },
  {
    path: "/syComp/syCompZs",
    name: "syCompZs",
    component: syCompZs,
    meta: {
      title: "证书信息",
      noCache: true,
      affix: true,
      path: ["企业管理", "证书信息"]
    },
  },
  {
    path: "/syComp/compDetail",
    name: "compDetail",
    component: sysCompDetail,
    meta: {
      title: "基本信息",
      noCache: true,
      affix: true,
      path: ["企业管理", "基本信息"]
    },
  },
  {
    path: "/syComp/syOperLog",
    name: "syOperLog",
    component: syOperLog,
    meta: {
      title: "操作日志",
      noCache: true,
      affix: true,
      path: ["企业管理", "操作日志"]
    },
  },
  {
    path: "/syComp/operator",
    name: "operator",
    component: operator,
    meta: {
      title: "操作员管理",
      noCache: true,
      affix: true,
      path: ["企业管理", "操作员管理"]
    },
  },
  {
    path: "/breed/batch",
    name: "batch",
    component: batch,
    meta: {
      title: "生产信息",
      noCache: true,
      affix: true,
      path: ["企业管理", "生产信息"]
    },
  },
  {
    path: "/syComp/device",
    name: "device",
    component: device,
    meta: {
      title: "设备信息",
      noCache: true,
      affix: true,
      path: ["企业管理", "设备信息"]
    },
  },
  {
    path: "/syPda/pdaVer",
    name: "syPdaVer",
    component: syPdaVer,
    meta: {
      title: "PDA版本信息",
      noCache: true,
      affix: true,
      path: ["PDA信息", "PDA版本信息"]
    },
  },
  {
    path: "/sySafe/safeDete",
    name: "safeDete",
    component: sySafeDete,
    meta: {
      title: "产品检测记录",
      noCache: true,
      affix: true,
      path: ["产品检测信息", "产品检测记录"]
    },
  },{
    path: "/syComp/labelComp",
    name: "labelComp",
    component: labelComp,
    meta: {
      title: "牧户耳标记录",
      noCache: true,
      affix: true,
      path: ["基础信息", "牧户耳标记录"]
    },
  }
];



// WEBPACK FOOTER //
// ./src/router/syComp.js